import * as React from "react";
const OpenMenuIcon = (props) => (
	<svg
		width={45}
		height={44}
		viewBox="0 0 45 44"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M.465 12c0-6.627 5.372-12 12-12h20c6.627 0 12 5.373 12 12v20c0 6.627-5.373 12-12 12h-20c-6.628 0-12-5.373-12-12z"
			fill="#9EA9AE"
		/>
		<path
			d="M20.465 29h-5v-5m9-9h5v5"
			stroke="#fff"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default OpenMenuIcon;
